import React, { useEffect } from 'react';
import { LanguageBar } from '../components/LanguageBar';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { Offers } from '../components/Offers';
import { Faq } from '../components/Faq';
import { FinalCta } from '../components/FinalCta';
import type { Content } from '../content/types';
type Props = {
  content: Content;
};
export function LandingPage({
  content
}: Props) {
  useEffect(() => {
    document.documentElement.lang = content.lang;
  }, [content.lang]);
  return <div className="min-h-screen bg-brand-dark font-sans selection:bg-brand-gold selection:text-brand-black" data-id="element-105">
      <LanguageBar activeLang={content.lang} data-id="element-106" />
      <main data-id="element-107">
        <Hero content={content.hero} data-id="element-108" />
        <Problem content={content.problem} data-id="element-109" />
        <Solution content={content.solution} data-id="element-110" />
        <Offers content={content.offers} data-id="element-111" />
        <Faq content={content.faq} data-id="element-112" />
        <FinalCta content={content.finalCta} data-id="element-113" />
      </main>
    </div>;
}